import usePlanningStore from './planning';
import useUsersAccessRightStore from '@/stores/users/accessRight';

export default function updateVisibleTimeline() {
  const { planning } = usePlanningStore();
  const mainStep = planning.timeline.getLastStep();
  const hidden = {
    before: planning.timeline.getHiddenBefore(),
    after: planning.timeline.getHiddenAfter(),
  };

  // Locale
  const planningLocale = planning.timeline.getTimelocale();
  const { timelineFormats } = useUsersAccessRightStore().config;
  const timelineFormat = planningLocale.slice(0, 2) == 'fr' ? timelineFormats.fr : timelineFormats.en; // { years: [{ xs: 'YYYY', s: 'YYYY', m: 'YYYY', l: 'YYYY' }], ... }

  //  ** Minute per pixel ** // set basis for col medium width
  const mainStepDuration = moment("2015-06-01T00:00:00").add(1, mainStep).diffWithWorkdays("2015-06-01T00:00:00", 'minutes', planning.timeline.getWorkdays());
  const minuteperpx = mainStepDuration / planning.timeline.getColWidth();

  // ** Cols **
  const timelineCols = [];

  for (let stepIndex = 0; stepIndex < planning.timeline.getSteps().length; stepIndex++) {
    const stepUnit = planning.timeline.getSteps()[stepIndex];
    timelineCols[stepIndex] = [];

    let submoment = moment(hidden.before);
    submoment.locale(planningLocale);
    let widthRest = 0;
    const workdays = planning.timeline.getWorkdays();
    if (workdays) submoment.toNextWorkday();
    while (submoment.isBefore(hidden.after, 'minute')) {
      const nextsubmoment = moment.min(moment(submoment).addWithWorkdays(1, stepUnit, workdays).startOf(stepUnit), hidden.after);
      const endtime = moment.min(moment(submoment).endOf(stepUnit).addWithWorkdays(1, 'second', workdays), moment(hidden.after));
      const colspan = endtime.diffWithWorkdays(submoment, 'minutes', workdays) / mainStepDuration;
      const decimalWidth = colspan * planning.timeline.getColWidth() + widthRest;
      const width = Math.round(decimalWidth);
      widthRest = decimalWidth - width;

      // label
      const colMeanWidth = Math.round(colspan) * planning.timeline.getColWidth();
      const size = colMeanWidth <= 50 ? 'xs' : colMeanWidth <= 100 ? 's' : colMeanWidth <= 160 ? 'm' : 'l';
      let timelineFormatIndex = stepIndex == 0 ? 0 : -1; // use first format for first step, last format for others
      if (stepUnit == 'weeks' && planning.timeline.getSteps().length == 1) timelineFormatIndex = -1; // if only weeks, use last format (to have first week day)
      const label = colspan > 0.6 ? submoment.format(timelineFormat[stepUnit].at(timelineFormatIndex)[size]) : '\u00A0';

      if (width > 0) timelineCols[stepIndex].push({ label, colspan: Math.round(colspan * 10000) / 10000, width, starttime: submoment.format(), endtime: endtime.format() });
      submoment = nextsubmoment;
    }
  }

  const timelinecols = timelineCols[0];
  const subtimelinecols = timelineCols[1] || [];

  // ** Pixel width **
  const timelinepxwidth = timelinecols.reduce((acc, col) => acc + col.width, 0);
  const subtimelinepxwidth = subtimelinecols.reduce((acc, col) => acc + col.width, 0);

  // Adjust timeline width to subtimelinewidth (due to width rounding; should not be more than 1px thanks to widthRest)
  let pxwidth;
  if (subtimelinecols.length) {
    let adjustment = subtimelinepxwidth - timelinepxwidth;
    for (let i = timelinecols.length - 1; i >= 0; i--) {
      timelinecols[i].width += adjustment;
      if (timelinecols[i].width >= 0) break;
      adjustment = timelinecols[i].width;
      timelinecols[i].width = 0;
    }
    pxwidth = subtimelinepxwidth;
  } else {
    pxwidth = timelinepxwidth;
  }

  // ** Presenttime Width **
  const presenttimeWidth = Math.round(moment().diffWithWorkdays(hidden.before, 'minutes', planning.timeline.getWorkdays()) / minuteperpx);

  planning.visibleTimeline = {
    starttime: hidden.before.format(),
    endtime: hidden.after.format(),
    pxwidth,
    minuteperpx,
    timelinecols,
    subtimelinecols,
    presenttimeWidth,
    workdays: planning.timeline.getWorkdays(),
    show_presenttime: planning.timeline.getShowPresenttime(),
    show_timegrid: planning.timeline.getShowTimegrid(),
  };
}
